import { compose, propEq, find } from 'ramda'

export const getEndCuepoint = compose(
  option => option && option.time,
  find(propEq('name', 'End'))
)
